import React from 'react';
import CountUp from 'react-countup';

const FunFactsSection = () => {
  return (
    <div id="fun-facts" className="fun-facts section overlay" style={{ backgroundColor: "#f1f1f1" }}>
      <div className="container">
        <div className="row">
          {/* Air-Warming Systems Installed */}
          <div className="col-lg-3 col-md-6 col-12">
            <div className="single-fun">
              <i className="icofont icofont-wind"></i> {/* Updated to wind icon */}
              <div className="content">
                <span className="counter">
                  <CountUp start={0} end={3468} duration={3} separator="," />
                </span>
                <p>Air-Warming Systems Installed</p>
              </div>
            </div>
          </div>

          {/* Successful Patient Warmings */}
          <div className="col-lg-3 col-md-6 col-12">
            <div className="single-fun">
              <i className="icofont icofont-hospital"></i> {/* Updated to hospital icon */}
              <div className="content">
                <span className="counter">
                  <CountUp start={0} end={557} duration={3} separator="," />
                </span>
                <p>Successful Patient Warmings</p>
              </div>
            </div>
          </div>

          {/* Warming Blankets Distributed */}
          <div className="col-lg-3 col-md-6 col-12">
            <div className="single-fun">
              <i className="icofont icofont-bed"></i> {/* Updated to bed icon */}
              <div className="content">
                <span className="counter">
                  <CountUp start={0} end={4379} duration={3} separator="," />
                </span>
                <p>Warming Blankets Distributed</p>
              </div>
            </div>
          </div>

          {/* Years of Experience in Warming Technology */}
          <div className="col-lg-3 col-md-6 col-12">
            <div className="single-fun">
              <i className="icofont icofont-clock-time"></i> {/* Time icon remains */}
              <div className="content">
                <span className="counter">
                  <CountUp start={0} end={15} duration={3} />
                </span>
                <p>Years of Experience in Warming Technology</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FunFactsSection;
